import React, { useState, useEffect } from 'react';

const LoadingScreen = () => {
  const quotes = [
    "Adventure awaits. Hold tight!",
    "Patience is the key. Your itinerary is on its way!",
    "Exploring the world takes time. Your journey is being prepared!",
    "In the meantime, dream big. Your adventure is loading!",
    "Every journey begins with a single step. Yours is loading now!",
    "The world is yours to discover. Hold on while we chart your course!"
  ];

  const [randomQuote, setRandomQuote] = useState('');

  useEffect(() => {
    // Select a random quote when the component mounts
    const randomIndex = Math.floor(Math.random() * quotes.length);
    setRandomQuote(quotes[randomIndex]);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-newcolor z-50 p-4">
      <img 
        src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExcnd2Ynlsb25iZDh5eHE3cjQxcGdzeno2YzExZzd0MHFmb3F0cDE5OCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/toelXGUsYD6vtCN408/giphy.gif" 
        alt="Loading" 
        className="animate-jump-in h-32 mb-4 max-w-full sm:h-40 md:h-48"
      />
      <blockquote className="animate-fade-up animate-once animate-ease-linear text-center text-gray-700 italic text-sm sm:text-base md:text-lg lg:text-xl">
        {randomQuote}
      </blockquote>
    </div>
  );
};

export default LoadingScreen;
